import React from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Grid, Typography } from '@material-ui/core';

// Product Development dashboard pager.
// Kept local (instead of the shared models/pagination/PaginationInput) so the
// clamping / disabled-arrow behaviour below applies to this dashboard only.
const PaginationSection = ({ totalPages, handlePageChange, currentPage }) => {
  // Never fewer than one page, so an empty result set still reads "1 out of 1".
  const pageCount = Math.max(1, Number(totalPages) || 1);
  // The page index must never run past the last page — a search that shrinks
  // the result set would otherwise leave the pager on a page that is gone.
  const page = Math.min(Math.max(1, Number(currentPage) || 1), pageCount);

  const isFirstPage = page <= 1;
  const isLastPage = page >= pageCount;

  const handleBack = () => {
    if (isFirstPage) return;
    handlePageChange(page - 1);
  };

  const handleNext = () => {
    if (isLastPage) return;
    handlePageChange(page + 1);
  };

  const arrowStyle = (disabled) => ({
    cursor: disabled ? 'default' : 'pointer',
    pointerEvents: disabled ? 'none' : 'auto',
  });

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      style={{ paddingTop: '0.5rem' }}
    >
      <ArrowBackIosIcon
        fontSize="small"
        titleAccess="Previous"
        onClick={handleBack}
        color={isFirstPage ? 'disabled' : 'action'}
        style={arrowStyle(isFirstPage)}
      />
      <Typography variant="body1" style={{ padding: '0 0.5rem' }}>
        {page} out of {pageCount} pages
      </Typography>
      <ArrowForwardIosIcon
        fontSize="small"
        titleAccess="Next"
        onClick={handleNext}
        color={isLastPage ? 'disabled' : 'action'}
        style={arrowStyle(isLastPage)}
      />
    </Grid>
  );
};

export default PaginationSection;
